
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Dropzone from 'react-dropzone';
import _ from 'lodash';
import PulpoField from '../../../pulpo_visualizer/fields';
import Clickable from '../../../components/clickable/Clickable';
import FormattedMessageWithClass from '../../../components/formattedMessageWithClass';
import styles from '../document.module.scss';
import { imageFileExtensions, docFileExtensions, checkMultiFilesValidation } from '../../../utils/helpers';

const Documents = ({
  handleAnswerChanged,
  handleFieldErrorChanged,
  info,
  showFormErrors,
  documentTypes
}) => {
  const handleDrop = (dropped) => {
    if (!checkMultiFilesValidation(dropped, `${imageFileExtensions} , ${docFileExtensions}`)) return;
    const res = info.attachments || [];
    const list = [...res, ...dropped];
    handleAnswerChanged(list, 'attachments');
  };

  const handleRemoveImage = (r) => {
    const res = info.attachments.filter(e => e !== r);
    handleAnswerChanged(res, 'attachments');
    const removedAttachments = info.removedAttachments || '';
    handleAnswerChanged([r.id, ...removedAttachments], 'removedAttachments');
  };

  return (
   <>
     <div className={styles.stepTwo}>
       <div className={styles.displayFlex}>
         <PulpoField key="document_type" id="document_type" type="select"
           transationID="lease.tenants.steps.step3.document_type"
           title="Document Type" isRequired disabled
           handleValueChange={(a, b) => handleAnswerChanged(a, b)}
           answer={info && info.document_type}
           showFieldErrors={showFormErrors}
           handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
           values={
            documentTypes?.length > 0 ? _.sortBy(documentTypes, ['name']).map(e => ({
              key: e.name,
              value: e.name
            })): []}
         />
         <PulpoField
           key="valid_date" id="valid_date" type="date" noDefault
           translationID="lease.tenants.steps.step3.valid_date"
           title="Valid Until" isRequired className={styles.datetime}
           handleValueChange={(a, b) => handleAnswerChanged(a, b)}
           answer={info && info.valid_date ? info.valid_date : ''}
           showFieldErrors={showFormErrors}
           handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
         />
       </div>
       <div className={styles.displayFlex}>
         <PulpoField
           key="description" id="description" type="string"
           widget={{ type: 'textarea' }}
           translationID="operations.create.description"
           title="Description"
           showFieldErrors={showFormErrors}
           handleValueChange={(a, b) => handleAnswerChanged(a, b)}
           answer={info && info?.description || ''}
           handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
         />
         <div className={styles.halfInput}>
           <FormattedMessageWithClass
             className={styles.label} id="lease.tenants.steps.step3.attachment"
             defaultMessage="Attachments"
           />
           <Dropzone
             onDrop={handleDrop}
             disableClick
             className={styles.dropzone}
             accept="image/*, .pdf, .doc"
           >
             {({ open }) => (
              <>
                <p className={styles.browsetext}>
                  <FormattedMessage id="airport.logo.text1" defaultMessage="Drag the attachment here " />
                  <button type="button" onClick={() => open()}>
                    <FormattedMessage id="airport.logo.button" defaultMessage="browse" />
                  </button>
                  <FormattedMessage id="airport.logo.text2" defaultMessage=" to upload." />
                </p>
              </>
             )}
           </Dropzone>
         </div>
       </div>
       <div className={styles.fullInput}>
         {info && info.attachments && info.attachments.length > 0 && (
         <div className={styles.photos}>
           {info.attachments.map(e => (
             <div key={e.name} className={styles.wrapper}>
               {((e.url && e.url.length > 0) || (e.preview && e.preview.length > 0))&& (
                  <>
                    <Clickable onClick={() => handleRemoveImage(e)}>&times;</Clickable>
                    {(e.type || e.content_type).includes('image') ? (
                      <img src={e.preview || e.url} alt={e.name || e.file_name} />
                    ) : <p>{e.name || e.file_name}</p>
                    }
                  </>
               )}
             </div>
           ))}
         </div>
         )}
       </div>
     </div>
   </>
  );
};

export default injectIntl(Documents);
